import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

export const initAnnouncement = () => {
    const banner = document.querySelector("#announcement");
    if (!banner) return;

    const root = document.documentElement;

    const setHeightVar = (val) => {
        root.style.setProperty("--announcement-height", `${val}px`);
    };

    const getHeight = () => {
        return (
            banner.getBoundingClientRect().height || banner.scrollHeight || 0
        );
    };

    const h = getHeight();

    ScrollTrigger.create({
        start: "top top",
        end: "+=80",
        onLeave: () => {
            gsap.to("#header", {
                y: -`${h}`,
                duration: 0.3,
            });
        },
        onEnterBack: () => {
            gsap.to("#header", {
                y: 0,
                duration: 0.3,
            });
        },
    });

    setHeightVar(h);
};
